import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const omsCommentSoldRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "OMS CommentSold" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        async lazy() {
          const { OmsCommentSoldCallback } = await import("./oms-commentsold");
          return { Component: OmsCommentSoldCallback };
        },
      },
    ],
  },
];

export const marketingCommentSoldRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Marketing CommentSold" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        async lazy() {
          const { MarketingCommentSoldCallback } =
            await import("./marketing-commentsold");
          return { Component: MarketingCommentSoldCallback };
        },
      },
    ],
  },
];
